export const getRandomInt = (min: number, max: number) => {
  if (min > max) throw new Error('최솟값이 최대값보다 큽니다.');
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
